import React from 'react';

export function linkFormatter(
  node: React.ReactNode,
  index: number,
): React.ReactNode {
  if (typeof node !== 'string') {
    return node;
  }

  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const segments: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = linkRegex.exec(node)) !== null) {
    if (match.index > lastIndex) {
      segments.push(node.slice(lastIndex, match.index));
    }
    segments.push(
      <a
        href={match[2]}
        className='alert-link'
        key={`${index}-link-${match.index}`}
      >
        {match[1]}
      </a>,
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex === 0) {
    return node;
  }

  if (lastIndex < node.length) {
    segments.push(node.slice(lastIndex));
  }

  return <React.Fragment key={`${index}-linkfmt`}>{segments}</React.Fragment>;
}
